import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { SkeletonPage } from 'components/common';
import { useTaskGetAllQuery, useTaskGroupsGetAllQuery } from 'hooks';
import { useAppLocation } from 'hooks/helpers';
import { taskRoutes } from 'router/taskRoutes';
import { setDraftTask, useTaskStore } from 'store/task';
import { TaskPageView } from './TaskPageView';

export const TaskPage = () => {
  const { data, isLoading } = useTaskGetAllQuery();
  const { isCreate, isNotFound } = useAppLocation(taskRoutes);
  const { taskId } = useParams<{ taskId: string }>();
  const { draft } = useTaskStore();

  useTaskGroupsGetAllQuery();

  useEffect(() => {
    if (!data?.length) return;

    if (taskId) {
      const active = data.find((task) => task.id === taskId);

      if (active) {
        setDraftTask({ task: active });
      }
    }
  }, [taskId, data]);

  if (isLoading) {
    return <SkeletonPage />;
  }

  if (draft?.id && !taskId && !isCreate && !isNotFound) {
    return <Navigate replace to={taskRoutes.taskId(draft.id)} />;
  }

  if (data?.length && !taskId && !isCreate && !isNotFound) {
    return <Navigate replace to={taskRoutes.taskId(data[0].id)} />;
  }

  const isTaskPresent = data?.some(({ id }) => id === taskId);

  if (taskId && !isTaskPresent) {
    return <Navigate replace to={taskRoutes.notFound} />;
  }

  return <TaskPageView />;
};
